module.exports = __webpack_public_path__ + "img/logo.72a0143c.svg";